export const titleObject = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  headlineOne: "社会人と交流しよう",
  headlineTwo: "新しい匿名SNSで",
  description: "匿名だけど信用できる、社会人のために作られた新しい SNS アプリ",
  buttonLabel: "ダウンロード",
  imgStart: "",
  src: "images/title_image.png",
  alt: "Workom",
};

export const anonymousHeroObject = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "ANONYMOUS",
  headline: "安全に匿名で会話",
  description:
    "Workom では、会話のためにハンドルネームを利用するので、相手に本名が伝わることはありません。また、メールアドレス等の個人情報も相手に伝わりませんので、誰とでも安全に会話ができます。",
  imgStart: "",
  src: "images/anonymous.svg",
  alt: "Anonymous",
};

export const experienceHeroObject = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "EXPERIENCE",
  headline: "聞きづらかった話までも",
  description:
    "Workom は、完全に匿名性を保っているので、上下関係や無駄な配慮をすることなく会話ができます。個人的な相談や、フランクな雑談までもがいつでも気軽に実現します。",
  imgStart: "start",
  src: "images/message.svg",
  alt: "Experience",
};

export const credibilityHeroObject = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "CREDIBILITY",
  headline: "安全に所属会社を認証",
  description:
    "Workom では、ユーザーの所属会社を認証するため、本人確認を行っております。本人確認のために社用メールアドレスを一度だけ使用しますが、他のユーザーが本名や社用メールアドレスを知ることはありません。",
  imgStart: "",
  src: "images/verified.svg",
  alt: "Credibility",
};

export const chatFeatureObject = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "CHAT",
  headline: "社会人と気軽にトーク",
  description:
    "社会人と色々なカテゴリーで気軽にチャット。同じ悩みを持った社会人と会話ができちゃう！なんと、「社内トピック」では、自分の会社の人とも匿名で気軽に話せちゃう！",
  imgStart: "",
  src: "images/topic_explanation.png",
  alt: "チャット画面 1",
  bottomPadding: false,
  largeImage: true,
};

export const employeeFeatureObject = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "EMPLOYEE",
  headline: "相手の会社名が分かる",
  description:
    "Workom では、ユーザの本人確認を行っているので、匿名なのにお互いの会社名だけは分かる！匿名だけど、相手の会社名だけは分かるので、手に入る情報が信頼できる！",
  imgStart: "start",
  src: "images/company_explanation.png",
  alt: "チャット画面 2",
  topPadding: false,
  largeImage: true,
};

export const applicationSubtitleObject = {
  lightBg: true,
  lightText: false,
  subtitle: "Workom とは？",
  topLine: "ABOUT",
};

export const featureSubtitleObject = {
  lightBg: false,
  lightText: true,
  subtitle: "Workom のここが凄い！",
  topLine: "FEATURE",
};

export const formSubtitleObject = {
  lightBg: true,
  lightText: false,
  subtitle: "ベータリリースに事前登録",
  topLine: "BETA RELEASE",
};

export const downloadAppSubtitleObject = {
  lightBg: true,
  lightText: false,
  subtitle: "Workom を始めよう！",
  topLine: "APPLICATION",
};
